/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { Component, type ReactElement } from 'react';
import type { LegacyBreadcrumbItem, LegacyBreadcrumbId } from '../types.tsx';
import type { State, Api } from './types.tsx';

type Props = {
	initialState: State;
	children: (arg1: { state: State; api: Api }) => ReactElement;
};

const compareBreadcrumbs = (a: LegacyBreadcrumbItem, b: LegacyBreadcrumbItem): number =>
	a.index - b.index;

const defaultInitialState: State = {
	trail: [],
	targetElement: null,
};

// eslint-disable-next-line jira/react/no-class-components
export default class LegacyBreadcrumbState extends Component<Props, State> {
	static defaultProps: {
		initialState: State;
	} = {
		initialState: defaultInitialState,
	};

	constructor(props: Props) {
		super(props);

		this.state = props.initialState;
	}

	onInsertItem = (item: LegacyBreadcrumbItem): void => {
		this.setState((state) => ({ trail: [...state.trail, item].sort(compareBreadcrumbs) }));
	};

	onRemoveItem = (id: LegacyBreadcrumbId): void => {
		this.setState((state) => ({ trail: state.trail.filter((b) => b.id !== id) }));
	};

	/* eslint-disable react/no-unused-state */
	onTargetSet = (targetElement: HTMLElement): void => {
		this.setState({ targetElement });
	};
	/* eslint-enable react/no-unused-state */

	api: Api = {
		setTargetElement: this.onTargetSet,
		insertItem: this.onInsertItem,
		removeItem: this.onRemoveItem,
	};

	render(): ReactElement {
		const { children } = this.props;
		return children({ state: this.state, api: this.api });
	}
}
